import styles from "../styles/Error.module.scss";

export const Error = ({ subject }: { subject: string }) => (
  <div>
    <img alt="" className={styles["error-image"]} src="/images/duo_sad.svg" />
    <h2 className={`${styles["eel"]} ${styles["error-text"]}`}>{subject}</h2>
  </div>
);
